(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var backdrop = document.getElementById('cart-drawer-backdrop');
    var drawer = document.getElementById('cart-drawer');
    var closeButton = document.getElementById('cart-drawer-close');
    var titleEl = document.getElementById('cart-drawer-title');
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    var promo = document.getElementById('cart-drawer-promo');
    var promoMsg = document.getElementById('cart-drawer-promo-msg');
    var promoFill = document.getElementById('cart-drawer-promo-fill');
    var moneyRain = document.getElementById('cart-drawer-money-rain');
    var i18n = drawer.dataset;
    var currentCart = null;
    var previousItemCount = 0;
    var hasRenderedOnce = false;

    var PROMO_TARGET = 2; // collections needed to unlock the free one
    var PROMO_TRIGGER = 3; // total items once the free one is in the cart — one-time, doesn't repeat

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function triggerMoneyMoment() {
      if (!moneyRain || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      for (var i = 0; i < 7; i++) {
        (function () {
          var glyph = document.createElement('span');
          glyph.className = 'cart-drawer__money-glyph';
          glyph.textContent = '$';
          glyph.style.left = (10 + Math.random() * 80) + '%';
          glyph.style.animationDelay = Math.round(Math.random() * 250) + 'ms';
          moneyRain.appendChild(glyph);
          setTimeout(function () {
            if (glyph.parentNode) glyph.parentNode.removeChild(glyph);
          }, 1500);
        })();
      }
    }

    function updateTitle(itemCount) {
      titleEl.textContent = itemCount > 0
        ? i18n.textTitle + ' (' + itemCount + ')'
        : i18n.textTitle;
    }

    function updatePromo(itemCount) {
      if (itemCount === 0) {
        promo.hidden = true;
        return;
      }
      promo.hidden = false;

      if (itemCount >= PROMO_TARGET) {
        promoFill.style.width = '100%';
        promoMsg.textContent = i18n.textPromoUnlocked;
      } else {
        promoFill.style.width = (itemCount / PROMO_TARGET) * 100 + '%';
        promoMsg.textContent = i18n.textPromoProgress.replace('{n}', PROMO_TARGET - itemCount);
      }
    }

    function displaySubtotal(cart) {
      var freeItem = cart.item_count >= PROMO_TRIGGER ? cart.items[PROMO_TRIGGER - 1] : null;
      return freeItem ? cart.total_price - freeItem.final_price : cart.total_price;
    }

    function openDrawer() {
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeDrawer() {
      backdrop.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        backdrop.hidden = true;
      }, 300);
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function renderCart(cart) {
      currentCart = cart;
      updateCartCount(cart.item_count);
      updateTitle(cart.item_count);
      updatePromo(cart.item_count);

      if (hasRenderedOnce && cart.item_count === PROMO_TARGET && previousItemCount < PROMO_TARGET) {
        triggerMoneyMoment();
      }
      previousItemCount = cart.item_count;
      hasRenderedOnce = true;

      if (cart.item_count === 0) {
        footer.hidden = true;
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p>' + i18n.textEmpty + '</p>' +
            '<a href="' + i18n.continueUrl + '" class="cart-drawer__empty-link">' + i18n.textContinue + '</a>' +
          '</div>';
        return;
      }

      footer.hidden = false;
      subtotalEl.textContent = formatMoney(displaySubtotal(cart));

      body.innerHTML = cart.items
        .map(function (item, index) {
          var showVariant = item.variant_title && item.variant_title !== 'Default Title';
          var isFree = cart.item_count >= PROMO_TRIGGER && index === PROMO_TRIGGER - 1;
          var priceHtml = isFree
            ? '<span class="cart-drawer__item-price cart-drawer__item-price--free">' + formatMoney(item.final_price) + '</span>' +
              '<span class="cart-drawer__item-free-label">' + i18n.textFree + '</span>'
            : '<span class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>';

          return (
            '<div class="cart-drawer__item" data-key="' + item.key + '">' +
              '<div class="cart-drawer__item-image">' +
                (item.image ? '<img src="' + item.image + '&width=180" alt="" loading="lazy">' : '') +
              '</div>' +
              '<div class="cart-drawer__item-details">' +
                '<div class="cart-drawer__item-top">' +
                  '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
                  '<button type="button" class="cart-drawer__remove" aria-label="' + i18n.textRemove + '">&times;</button>' +
                '</div>' +
                '<div class="cart-drawer__item-price-row">' + priceHtml + '</div>' +
                (showVariant ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
              '</div>' +
            '</div>'
          );
        })
        .join('');
    }

    function changeItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          return response.json();
        })
        .then(renderCart);
    }

    function refreshCart() {
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(renderCart);
    }

    body.addEventListener('click', function (event) {
      var removeButton = event.target.closest('.cart-drawer__remove');
      if (!removeButton) return;
      var item = event.target.closest('.cart-drawer__item');
      changeItem(item.dataset.key, 0);
    });

    closeButton.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });

    document.addEventListener('open-cart', function () {
      openDrawer();
      refreshCart();
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('form[action^="/cart/add"]')) return;
      event.preventDefault();

      var formData = new FormData(event.target);

      // Each product is a single license — one per cart, no stacking quantity.
      var variantId = formData.get('id');
      var alreadyInCart = currentCart && currentCart.items.some(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      if (alreadyInCart) {
        document.dispatchEvent(new CustomEvent('open-cart'));
        return;
      }

      formData.set('quantity', '1');

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function () {
          document.dispatchEvent(new CustomEvent('open-cart'));
        });
    });

    refreshCart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-slider"] && !Shopify.designMode) return;
  try {
    
  /*
   * The range input alone isn't enough to drag on touch: iOS Safari only
   * starts a drag when the touch lands exactly on the (invisible, ~44px)
   * thumb, not anywhere on the track like desktop click does. So dragging
   * is driven by pointer events on the whole frame instead — the input
   * stays underneath purely for keyboard control (arrow keys), synced via
   * its own 'input' listener below.
   */
  function setPosition(frame, input, value) {
    var clamped = Math.min(100, Math.max(0, value));
    frame.style.setProperty('--position', clamped + '%');
    input.value = clamped;
  }

  function percentFromEvent(frame, event) {
    var rect = frame.getBoundingClientRect();
    return ((event.clientX - rect.left) / rect.width) * 100;
  }

  function setUpCompareSlider(frame) {
    var input = frame.querySelector('.compare-slider__input');
    if (!input) return;

    var dragging = false;

    frame.addEventListener('pointerdown', function (event) {
      dragging = true;
      frame.setPointerCapture(event.pointerId);
      setPosition(frame, input, percentFromEvent(frame, event));
    });

    frame.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      setPosition(frame, input, percentFromEvent(frame, event));
    });

    frame.addEventListener('pointerup', function (event) {
      dragging = false;
      frame.releasePointerCapture(event.pointerId);
    });

    frame.addEventListener('pointercancel', function () {
      dragging = false;
    });

    input.addEventListener('input', function () {
      frame.style.setProperty('--position', input.value + '%');
    });
  }

  function setUpAllCompareSliders(root) {
    root.querySelectorAll('.compare-slider__frame').forEach(setUpCompareSlider);
  }

  setUpAllCompareSliders(document);
  document.addEventListener('shopify:section:load', function (event) {
    setUpAllCompareSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tabButton = event.target.closest('.featured-products__tab');
    if (!tabButton) return;

    var container = tabButton.closest('.featured-products');
    if (!container) return;

    container.querySelectorAll('.featured-products__tab').forEach(function (button) {
      var isActive = button === tabButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var target = tabButton.dataset.tab;
    container.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.tabPanel !== target;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-icon-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('open-cart'));
      });
    });

    var trigger = document.getElementById('nav-drawer-trigger');
    var backdrop = document.getElementById('nav-drawer-backdrop');
    var drawer = document.getElementById('nav-drawer');
    var closeButton = document.getElementById('nav-drawer-close');

    if (!trigger || !drawer) return;

    function openDrawer() {
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeDrawer() {
      backdrop.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        backdrop.hidden = true;
      }, 300);
    }

    trigger.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product').forEach(function (root) {
    var mainImg = root.querySelector('.product__main-img');
    var thumbs = root.querySelectorAll('.product__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg && thumb.dataset.fullSrc) {
          mainImg.src = thumb.dataset.fullSrc;
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    var form = root.querySelector('.product__form');
    if (!form) return;

    var idInput = form.querySelector('.product__variant-id');
    var ctaButton = root.querySelector('.product__cta');
    var buyNowButton = root.querySelector('.product__buy-now');

    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        if (buyNowButton.disabled) return;

        var formData = new FormData(form);
        formData.set('quantity', '1');
        buyNowButton.disabled = true;

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (response) {
            if (!response.ok) throw new Error('add to cart failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowButton.disabled = false;
          });
      });
    }

    var optionInputs = form.querySelectorAll('.product__option-input');
    if (!optionInputs.length) return;

    var variantEls = root.querySelectorAll('.product__variant-data [data-variant-id]');
    var ctaText = root.querySelector('.product__cta-text');
    var priceCurrent = root.querySelector('.product__price-current');
    var priceCompareEl = root.querySelector('.product__price-compare');

    function selectedOptionsKey() {
      var checked = Array.prototype.slice.call(form.querySelectorAll('.product__option-input:checked'));
      checked.sort(function (a, b) {
        return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
      });
      return checked.map(function (input) {
        return input.value;
      }).join('||');
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var key = selectedOptionsKey();
        var match = null;
        variantEls.forEach(function (el) {
          if (el.dataset.variantOptions === key) match = el;
        });
        if (!match) return;

        idInput.value = match.dataset.variantId;
        priceCurrent.textContent = match.dataset.variantPrice;

        if (match.dataset.variantCompare) {
          if (!priceCompareEl) {
            priceCompareEl = document.createElement('s');
            priceCompareEl.className = 'product__price-compare';
            priceCurrent.insertAdjacentElement('afterend', priceCompareEl);
          }
          priceCompareEl.textContent = match.dataset.variantCompare;
          priceCompareEl.hidden = false;
        } else if (priceCompareEl) {
          priceCompareEl.hidden = true;
        }

        var available = match.dataset.variantAvailable === 'true';
        ctaButton.disabled = !available;
        ctaText.textContent = available
          ? ctaButton.dataset.labelAvailable
          : ctaButton.dataset.labelSoldOut;
        if (buyNowButton) buyNowButton.disabled = !available;

        if (match.dataset.variantImage && mainImg) {
          mainImg.src = match.dataset.variantImage;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
